<template>
  <div class="cool-ui-loading"
       v-if="show"
       :style="{ backgroundColor: bgColor }"
  >
    <div class="content">
      <img src="https://coolcdn.igetcool.com/p/2023/12/4b78239cb77a319b22faadc4a5ef7f27.gif" alt class="icon">
      <p class="text" v-html="text"></p>
    </div>
  </div>
</template>

<script>
/**
 * 每位工程师都有保持代码优雅的义务
 * each engineer has a duty to keep the code elegant
 */

export default {
  name: 'CoolMLoading',
  props: {
    show: {
      type: Boolean,
      required: false,
      default: false
    },
    bgColor: {
      type: String,
      required: false,
      default: 'rgba(0, 0, 0, 0.5)'
    },
    text: {
      type: String,
      required: false,
      default: '加载中...'
    }
  },
};
</script>

<style lang="stylus">
$content-padding-right = 8px

@keyframes cool-loading-kf-fadein
  0%
    opacity 0.4
  100%
    opacity 1

.cool-ui-loading
  position fixed
  left 0
  right 0
  top 0
  bottom 0
  z-index 9999
  animation 0.3s cool-loading-kf-fadein

  .content
    display flex
    align-items center
    justify-content center
    height 100%
    margin-left -($content-padding-right)
    margin-top -20px

  .icon
    width 20px
    height 20px
    margin-right $content-padding-right

  .text
    font-size 20px
    color #ffffff

</style>
